/**
 * React Hook for managing conversations list
 * Uses ConversationsContext for centralized state management
 */

import { useConversationsContext } from '../contexts/ConversationsContext';
import { Conversation } from '../types/conversations';

export interface UseConversationsReturn {
  conversations: Conversation[];
  loading: boolean;
  error: string | null;
  hasMore: boolean;
  refresh: () => Promise<void>;
  loadMore: () => Promise<void>;
}

export const useConversations = (): UseConversationsReturn => {
  const {
    conversations,
    conversationsLoading,
    conversationsError,
    hasMoreConversations,
    refreshConversations,
    loadMoreConversations,
  } = useConversationsContext();

  return {
    conversations,
    loading: conversationsLoading,
    error: conversationsError,
    hasMore: hasMoreConversations,
    refresh: refreshConversations,
    loadMore: loadMoreConversations,
  };
};
